import React from 'react';
import ArrowIndicator from '../icons/ArrowIndicator';
import * as S from './ConditionGradient.styles';
const ConditionGradient = ({
  value,
  label,
  axisLabels = [],
  compact = false
}) => {
  const renderLabel = label => /*#__PURE__*/React.createElement(S.Label, {
    key: label
  }, label);
  return /*#__PURE__*/React.createElement(S.Root, {
    compact: compact
  }, /*#__PURE__*/React.createElement(S.Label, null, label), /*#__PURE__*/React.createElement(S.Container, {
    compact: compact
  }, /*#__PURE__*/React.createElement(S.Indicator, {
    value: value,
    compact: compact
  }, /*#__PURE__*/React.createElement(ArrowIndicator, null)), /*#__PURE__*/React.createElement(S.Gradient, null), /*#__PURE__*/React.createElement(S.AxisLabels, null, axisLabels.map(renderLabel))));
};
export default ConditionGradient;